import React from 'react';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-brand-bg text-black py-12 border-t border-black/10" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-21">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-22">
          <div className="text-center md:text-left" data-id="element-23">
            <h3 className="text-xl font-bold mb-2 text-black" data-id="element-24">
              INTERVENCIÓN DIGITAL
            </h3>
            <p className="text-black/80" data-id="element-25">
              Materiales para profesionales de la salud mental y la educación.
            </p>
          </div>

          <div className="flex gap-6" data-id="element-26">
            <a href="#" className="flex items-center gap-2 text-black/80 hover:text-black transition-colors" data-id="element-27">
              <Instagram className="w-5 h-5" data-id="element-28" />
              <span data-id="element-29">Instagram</span>
            </a>
            <a href="#" className="flex items-center gap-2 text-black/80 hover:text-black transition-colors" data-id="element-30">
              <Mail className="w-5 h-5" data-id="element-31" />
              <span data-id="element-32">Email de contacto</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-black/10 text-center text-black/60 text-sm" data-id="element-33">
          <p data-id="element-34">© 2025 Intervención Digital · Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}